import React from "react";
import "./Checkbox.scss";
import Input from "../Input/Input.js";
import PropTypes from "prop-types";
import { bem } from "../../helpers";
import "./Checkbox.scss";

/**
 * @typedef {object} CheckboxProps
 * @prop {string} id
 * @prop {string} parentId
 * @prop {string} label
 * @prop {Function} onChange
 * @prop {object} formData
 * @prop {object} formErrors
 * @prop {Function} validate
 * @prop {boolean} displayErrors
 * @prop {boolean} disabled
 * @prop {boolean} nested
 * @prop {string} format
 *
 * @augments {React.Component<CheckboxProps>}
 */
export class Checkbox extends Input {
  inputType = "checkbox";

  valueFromEvent = (event) => {
    return !!event.target.checked;
  };

  render() {
    return (
      <div
        className={bem(
          "checkbox",
          "",
          [!this.props.label && "no-label"],
          this.props.className
        )}
      >
        <input
          id={this.props.id}
          name={this.name()}
          type={this.inputType}
          value={this.value()}
          checked={this.props.checked}
          className={bem("field", "input")}
          disabled={this.props.disabled}
          {...this.inputProps}
          onChange={this.onChange}
        />
        <label
          htmlFor={this.props.id}
          {...this.labelProps}
          className={bem("field", "label", [], this.props.className)}
        >
          {this.props.label}
        </label>
      </div>
    );
  }
}

export default Checkbox;
